module.exports = __webpack_public_path__ + "static/media/pexels-aron-visuals-1743165.16ba4f00.jpg";